import { defaultOptions } from './clickToCall.contracts.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function clickToCall(options = defaultOptions) {
    if (!(typeof window === 'object' && 'open' in window)) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    const analytics = _extends({}, defaultOptions.analytics, options.analytics);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.dataLayer.push(_extends({
        event: 'ga4',
        event_name: 'click_cta'
    }, analytics));
    var _options_web;
    const web = (_options_web = options.web) != null ? _options_web : defaultOptions.web;
    if (web) {
        const webUrl = options.webUrl || defaultOptions.webUrl;
        const windowFeatures = options.windowFeatures || defaultOptions.windowFeatures;
        window.open(webUrl, '_blank', windowFeatures);
    } else {
        const appUrl = options.appUrl || defaultOptions.appUrl;
        window.open(appUrl, '_blank');
    }
}

export { clickToCall };
//# sourceMappingURL=clickToCall.js.map
